// 使用统一的请求管理器
import { unifiedGet, unifiedPost } from "./requestManager";

/**
 * 封装get方法 - 专门用于health.mvectortech.com
 * @param url
 * @param data
 * @returns {Promise}
 */
export function mget(type,url, params = {}) {
  // 确保URL以/health/开头，这样会被路由到health axios实例
  return unifiedGet(type,url, params);
}

/**
 * 封装post请求 - 专门用于health.mvectortech.com
 * @param url
 * @param data
 * @returns {Promise}
 */
export function mpost(type,url, data = {}) {
  // 确保URL以/health/开头，这样会被路由到health axios实例
  return unifiedPost(type,url, data);
}



// WEBPACK FOOTER //
// ./src/utils/mxios.js